import React from 'react';
import { Outlet } from 'react-router-dom';

//Loads screens/items dynamically.
//No custom, always 1 to 1.

const PublicDomain = () => {
    return <Outlet />;
};

export default PublicDomain;
